import React, { Component } from 'react'

export default class AdminFooter extends Component {
  render() {
    return (
      <div>
        <footer className="main-footer">
          <strong>Copyright © <a href="#">TIGPS</a>.</strong>
          All rights reserved.
        </footer>
      </div>

    )
  }
}
